import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/Privacy.css';

export class PageNotFound extends Component {


    render() {
        return (
            <Container fluid center="true">
                <Row><Col><h1>Page Not Found</h1></Col></Row>
                <Row><Col><h4>Invalid link - Page does not exist</h4></Col></Row>
                <Row><Col>
                    <p>Validate the URL or use the site's navigation to find a valid page</p>                    
                </Col>
                </Row>
            </Container>
        );
    }
}